/**
 * Centralized route paths for navigation and route matching.
 * Use these constants instead of hard-coding paths to keep routing maintainable.
 */
export const RoutePaths = {
  /** First-time company creation (post-login). Nav is hidden until form is submitted. */
  COMPANY_REGISTER: "/company/register",
  PAFS: "/pafs",
  COMPANIES: "/companies",
} as const;

export type RoutePathsType = typeof RoutePaths[keyof typeof RoutePaths];
